module.exports = __webpack_public_path__ + "static/media/banner7.0cf5d0c0.png";